import store from '../../vuex/store'
export default {
    store,
    install (Vue, options) {
        Vue.prototype.$vueStore = store
    }
}



// WEBPACK FOOTER //
// ./src/plugins/store/index.js